import { render, staticRenderFns } from "./info.vue?vue&type=template&id=6f019bc0&scoped=true&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./info.vue?vue&type=style&index=1&id=6f019bc0&scoped=true&lang=css&"
import style2 from "./info.vue?vue&type=style&index=2&id=6f019bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f019bc0",
  null
  
)

export default component.exports